"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.377 0c.271 0 .47.168.51.421l.008.099v22.96c0 .272-.168.471-.42.512l-.098.008H9.623a.493.493 0 0 1-.51-.422l-.009-.098V.52c0-.273.17-.472.421-.512L9.624 0h4.752Zm8.708 4.75c.273 0 .47.17.51.422l.009.099V23.48c0 .272-.168.471-.42.512l-.099.008h-4.75a.495.495 0 0 1-.513-.422l-.008-.098V5.271c0-.273.17-.472.423-.513l.099-.008h4.75ZM5.666 11.085c.272 0 .472.168.513.42l.007.099V23.48a.493.493 0 0 1-.421.512L5.666 24H.916a.494.494 0 0 1-.512-.422l-.008-.098V11.604c0-.272.169-.47.422-.511l.098-.008h4.75Zm8.19-10.046h-3.711v21.922h3.71V1.039Zm8.71 4.751h-3.712v17.171h3.712V5.79Zm-17.42 6.334h-3.71v10.837h3.71V12.124Z",
    clipRule: "evenodd"
  })]
});